import { Container, Typography } from '@mui/material'
import React from 'react'
import styles from './trackingAddressesStyles'
import { ArrowRight } from 'iconsax-react'

const TrackingAddresses = ({guide}) => {
  return (
    <Container style={styles.mainContainer}>
      <Typography variant="h6" sx={styles.title}>Direcciones</Typography>
      <Container sx={styles.secondaryContainer}>
        <Container sx={styles.sectionContainer}>
          <Typography variant="h6" sx={styles.subtitle}>Origen</Typography>
          <Typography variant="body2">Remitente</Typography>
          <Typography variant="subtitle1" sx={styles.data}>{guide?.guide_info?.origin_info?.sender ?? 'Desconocido'}</Typography>
          <Typography variant="body2">Dirección</Typography>
          <Typography variant="subtitle2" sx={styles.data}>
            {guide?.guide_info?.origin_info?.street_name} {guide?.guide_info?.origin_info?.colony} {guide?.guide_info?.origin_info?.ext_number ? `ext. #${guide?.guide_info?.origin_info?.ext_number}` : ''} {guide?.guide_info?.origin_info?.int_number ? `int. ${guide?.guide_info?.origin_info?.int_number}` : ''} {guide?.guide_info?.origin_info?.postal_code ? `cp. ${guide?.guide_info?.origin_info?.postal_code}` : ''} {guide?.guide_info?.origin_info?.city} {guide?.guide_info?.origin_info?.state} 
          </Typography>
        </Container>
        <ArrowRight size={70} sx={styles.icon} />
        <Container sx={styles.sectionContainer}>
          <Typography variant="h6" sx={styles.subtitle}>Destino</Typography>
          <Typography variant="body2">Destinatario</Typography>
          <Typography variant="subtitle1" sx={styles.data}>{guide?.guide_info?.destiny_info?.recipient ?? 'Desconocido'}</Typography>
          <Typography variant="body2">Dirección</Typography>
          <Typography variant="subtitle2" sx={styles.data}>
            {guide?.guide_info?.destiny_info?.street_name} {guide?.guide_info?.destiny_info?.colony} {guide?.guide_info?.destiny_info?.ext_number ? `ext. #${guide?.guide_info?.destiny_info?.ext_number}` : ''} {guide?.guide_info?.destiny_info?.int_number ? `int. ${guide?.guide_info?.destiny_info?.int_number}` : ''} {guide?.guide_info?.destiny_info?.postal_code ? `cp. ${guide?.guide_info?.destiny_info?.postal_code}` : ''} {guide?.guide_info?.destiny_info?.city} {guide?.guide_info?.destiny_info?.state} 
          </Typography>
        </Container>
      </Container>
    </Container>
  )
}

export default TrackingAddresses